<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h1 class="u">
      Клиенты
      <span v-if="total">({{ total }})</span>
    </h1>

    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <label>Район</label>
          <el-select
            v-model="filters.apartment__block__building__address__district__id"
            filterable
            @change="loadAddresses()">
            <el-option value="" label="- Все -"></el-option>
            <el-option
              v-for="option in selectDistricts"
              :key="option.value"
              :label="option.label"
              :value="option.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label>Улица</label>
          <el-select
            v-model="filters.apartment__block__building__address__id"
            filterable
            @change="loadBuildings()">
            <el-option value="" label="- Все -"></el-option>
            <el-option
              v-for="option in selectAddresses"
              :key="option.value"
              :label="option.label"
              :value="option.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label>№ дома</label>
          <el-select
            v-model="filters.apartment__block__building__id"
            filterable
            @change="loadBlocks()">
            <el-option value="" label="- Все -"></el-option>
            <el-option
              v-for="option in selectBuildings"
              :key="option.value"
              :label="option.label"
              :value="option.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label>№ подъезда</label>
          <el-select
            v-model="filters.apartment__block__id"
            filterable>
            <el-option value="" label="- Все -"></el-option>
            <el-option
              v-for="option in selectBlocks"
              :key="option.value"
              :label="option.label"
              :value="option.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label>Номер договора</label>
          <input type="text" class="form-control" v-model="filters.search">
        </div>
      </div>
    </div>

    <div v-if="filters.apartment__block__id">
      <div class="row">
        <div class="col-md-3">
          <div class="form-group">
            <label>Начальная дата</label>
            <el-date-picker
              v-model="dateFrom"
              input-id="date-from"
              input-class="form-control"
              type="date"
              placeholder="Начальная дата">
            </el-date-picker>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Конечная дата</label>
            <el-date-picker
              v-model="dateTo"
              input-id="date-to"
              input-class="form-control"
              type="date"
              placeholder="Конечная дата">
            </el-date-picker>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Количество месяцев</label>
            <input type="text" class="form-control" v-model="months">
          </div>
        </div>
        <div class="col-md-3">
          <div style="margin-top: 25px;" class="text-right">
            <a class="btn btn-primary" href="#" @click.prevent="printBills">напечатать квитанции</a>
          </div>
        </div>
        <div class="col-md-3">
          <div style="margin-top: 25px;" class="text-right">
            <a class="btn btn-primary" href="#" @click.prevent="createPrintOrder">создать заказ на печать</a>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <div class="form-group">
            <label>Начальная дата 2</label>
            <el-date-picker
              v-model="dateFrom2"
              input-id="date-from2"
              input-class="form-control"
              type="date"
              placeholder="Начальная дата 2">
            </el-date-picker>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Конечная дата 2</label>
            <el-date-picker
              v-model="dateTo2"
              input-id="date-to2"
              input-class="form-control"
              type="date"
              placeholder="Конечная дата 2">
            </el-date-picker>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Количество месяцев 2</label>
            <input type="text" class="form-control" v-model="months2">
          </div>
        </div>
      </div>
    </div>

    <resource-list
      url="/clients"
      current-sort="contract_number"
      init-sort-type="asc"
      resource-name="clients"
      :action-routes="actionRoutes"
      :fields="fields"
      :filters="filters"
      :show-in-query="showInQuery"
      :init-page="initPage"
      :init-per-page="initPerPage"
      :storagePrfx="'all-clients'"
      @total="updateTotal"
    />

  </div>
</template>

<script>
import resourceList from '@/components/ResourceList'
import helpers from '@/helpers'
import { getList } from '@/services/__common.service'
import { printBills } from '@/services/block.service'
import { addPrintOrder } from '@/services/print_order.service'

export default {
  name: 'all-clients',
  components: { resourceList },
  mounted () {
    this.loadDistricts()
  },
  data () {
    return {
      months: '',
      dateFrom: '',
      dateTo: '',
      months2: 1,
      dateFrom2: null,
      dateTo2: null,

      total: null,

      selectDistricts: [],
      selectAddresses: [],
      selectBuildings: [],
      selectBlocks: [],

      fields: [
        { name: 'full_name', label: 'Адрес', sort: false },
        { name: 'contract_number', label: '№ договора', sort: true },
        { name: 'balance', label: 'Баланс', sort: true, money: true }
      ],
      filters: {
        search: this.loadFromQueryParams(this.$route, 'search'),
        apartment__block__building__address__district__id: this.loadFromQueryParams(this.$route, 'apartment__block__building__address__district__id'),
        apartment__block__building__address__id: this.loadFromQueryParams(this.$route, 'apartment__block__building__address__id'),
        apartment__block__building__id: this.loadFromQueryParams(this.$route, 'apartment__block__building__id'),
        apartment__block__id: this.loadFromQueryParams(this.$route, 'apartment__block__id')
      },
      initPage: this.loadFromQueryParams(this.$route, 'page', '1'),
      initPerPage: this.loadFromQueryParams(this.$route, 'per_page', '10'),
      showInQuery: [
        'search',
        'apartment__block__building__address__district__id',
        'apartment__block__building__address__id',
        'apartment__block__building__id',
        'apartment__block__id',
        'page',
        'per_page'
      ],
      actionRoutes: [
        { name: 'client-details', idName: 'client_id', label: 'Открыть детали' }
      ]
    }
  },
  methods: {
    loadFromQueryParams: helpers.loadFromQueryParams,
    loadDistricts () {
      getList('/districts', 'name', 'asc', {}, true, 1, 100).then((response) => {
        this.selectDistricts = response.data['results'].map(district => {
          return { value: '' + district.id, label: district.name }
        })
        this.loadAddresses()
      })
    },
    loadAddresses () {
      if (this.filters.apartment__block__building__address__district__id) {
        getList('/addresses', 'name', 'asc', {district: this.filters.apartment__block__building__address__district__id}, true, 1, 100).then((response) => {
          this.selectAddresses = response.data['results'].map(address => {
            return { value: '' + address.id, label: address.name }
          })
          this.loadBuildings()
        })
      }
    },
    loadBuildings () {
      if (this.filters.apartment__block__building__address__id) {
        getList('/buildings', 'number', 'asc', {address: this.filters.apartment__block__building__address__id}, true, 1, 100).then((response) => {
          this.selectBuildings = response.data['results'].map(building => {
            return { value: '' + building.id, label: building.number }
          })
          this.loadBlocks()
        })
      }
    },
    loadBlocks () {
      if (this.filters.apartment__block__building__id) {
        getList('/blocks', 'number', 'asc', {building: this.filters.apartment__block__building__id}, true, 1, 100).then((response) => {
          this.selectBlocks = response.data['results'].map(block => {
            return { value: '' + block.id, label: block.number }
          })
        })
      }
    },
    printBills () {
      let dateFrom
      let dateTo
      let dateFrom2
      let dateTo2

      if (this.dateFrom) {
        dateFrom = this.dateFrom.toJSON()
      } else {
        dateFrom = this.dateFrom
      }
      if (this.dateTo) {
        dateTo = this.dateTo.toJSON()
      } else {
        dateTo = this.dateTo
      }

      if (this.dateFrom2) {
        dateFrom2 = this.dateFrom2.toJSON()
      } else {
        dateFrom2 = this.dateFrom2
      }
      if (this.dateTo2) {
        dateTo2 = this.dateTo2.toJSON()
      } else {
        dateTo2 = this.dateTo2
      }

      printBills(this.filters.apartment__block__id, this.months, dateFrom, dateTo, this.months2, dateFrom2, dateTo2).then((response) => {
        let file = new Blob([response.data], {type: 'application/pdf'})
        let fileURL = URL.createObjectURL(file)
        window.open(fileURL)
      }).catch(err => {
        console.log(err.response)
      })
    },
    formatDate (date) {
      function pad (n) { return n < 10 ? '0' + n : n }

      return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate())
    },
    createPrintOrder () {
      let printOrderData = {
        from_date: this.formatDate(this.dateFrom),
        to_date: this.formatDate(this.dateTo),
        months: this.months,
        block: this.filters.apartment__block__id
      }

      if (this.dateFrom2) {
        printOrderData.from_date2 = this.formatDate(this.dateFrom2)
      }
      if (this.dateTo2) {
        printOrderData.to_date2 = this.formatDate(this.dateTo2)
      }
      if (this.months2) {
        printOrderData.months2 = this.months2
      }

      addPrintOrder(printOrderData).then(response => {
        console.log(response)
      }).catch(err => {
        console.log(err.response)
      })
    },
    updateTotal (val) {
      this.total = val
    }
  }
}
</script>


// WEBPACK FOOTER //
// AllClients.vue?31ddcca2